import * as React from "react";

// NPM
import { animated } from "react-spring";
import clsx from "clsx";
import moment from "moment";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Grid, GridProps } from "@material-ui/core";

// Utility
import Utility from "../../domain/classes/Utility";

// Icons
import GroupRoundedIcon from "@material-ui/icons/GroupRounded";
import DevicesRoundedIcon from "@material-ui/icons/DevicesRounded";

// Components
import { AnimatedAttributeContainer } from "../appointmentTypeSelection/AttributeContainer.Component";

// Interfaces
import IDoctor from "../../domain/interfaces/IDoctor";
import ITelehealthDay from "../../domain/interfaces/ITelehealthDay";

// Classes
import Doctor from "../../domain/classes/Doctor";
import IAppointmentRecord from "../../domain/interfaces/IAppointmentRecord";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
	});

export interface DeliveryMethodToolbarProps extends GridProps {
	doctor: IDoctor;
	data: IAppointmentRecord;
}

const DeliveryMethodToolbar = React.forwardRef<
	HTMLDivElement,
	DeliveryMethodToolbarProps & WithStyles<typeof styles>
>(({ classes, className, doctor, data, ...gridProps }, ref) => {
	const [provideOnsite, setProvideOnsite] = React.useState<boolean>(false);

	React.useEffect(() => {
		setProvideOnsite(
			Doctor.provides(
				"onsiteAlso",
				doctor.TelehealthDays as ITelehealthDay[],
				moment(data.dateAt).isoWeekday()
			)
		);
	}, [doctor, data.dateAt]);

	return (
		<Grid
			container
			spacing={1}
			{...gridProps}
			ref={ref}
			className={clsx(classes.root, className)}
		>
			{provideOnsite && (
				<AnimatedAttributeContainer
					Icon={GroupRoundedIcon}
					text="Face-to-face"
				/>
			)}

			<AnimatedAttributeContainer
				Icon={DevicesRoundedIcon}
				text="Telehealth"
			/>
		</Grid>
	);
});

const StyledDeliveryMethodToolbar = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("DeliveryMethodToolbar"),
})(DeliveryMethodToolbar);

export default StyledDeliveryMethodToolbar;

export const AnimatedDeliveryMethodToolbar = animated(
	StyledDeliveryMethodToolbar
);
